<aux-table-panel>
  <div class="flex items-center justify-between p-4">
    <div class="text-[16px] font-bold leading-[20px]">Balance Sheet Accounts</div>
    <div class="flex items-center gap-4">
      <aux-button
        variant="secondary"
        [iconSize]="20"
        icon="Eye"
        label="View Journal Entries"
        (click)="viewJournalEntries()"
      />
      <div class="h-[40px] border-r border-r-aux-gray-light-2"></div>
      <aux-export-excel-button [clickFN]="exportData" />
      <aux-button
        [auxTooltip]="manageBalanceSheetsAccountsPermissionTooltip()"
        [disabled]="!permissions().manageBalanceSheetsAccounts"
        label="Edit"
        classList="px-[20px]"
        (clickEmit)="openManageBalanceSheetsAccountsModal()"
      />
    </div>
  </div>

  @if (loading()) {
    <aux-table-skeleton />
  } @else {
    @if (rowData().length > 0) {
      <ag-grid-angular
        class="new-flat-theme h-[500px] w-full tabular-nums"
        [rowData]="rowData()"
        [gridOptions]="gridOptions()"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
      />
    } @else {
      <div class="flex items-center justify-center p-8 text-gray-500">
        No balance sheet accounts to display.
      </div>
    }
  }
</aux-table-panel>
